export const COMMISSIONS_SETTINGS_RANKS_ROUTE_PREFIX = "/commissions/ranks";

export const COMMISSIONS_SETTINGS_RANKS_ROUTE_PATHS = {
  list: { path: "*", to: COMMISSIONS_SETTINGS_RANKS_ROUTE_PREFIX },
};
